
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },

    category: {
      type: Object,
      default: () => {},
    },

    date: {
      type: String,
      default: '',
    },
  },

  computed: {
    correspondingDate() {
      if (this.data.from) {
        return this.$dateFns.format(new Date(this.data.from), 'dd.MM.yyyy')
      }
      if (this.date) {
        return this.$dateFns.format(new Date(this.date), 'dd.MM.yyyy')
      }
      return null
    },

    hasImage() {
      return !!this.data?.image
    },

    /**
     * Generate parent url of current page
     */
    backLink() {
      const spitted = this.$route.path.split('/')
      const urlFragments = spitted.slice(1, spitted.length - 1)
      const parentUrl = '/' + urlFragments.join('/')

      return parentUrl
    },
  },

  created() {
    this.$nuxt.$emit('none-gradient-hero-created')
  },

  async mounted() {
    await this.$nextTick()

    this.initAnimation()
  },

  methods: {
    initAnimation() {
      const q = this.$gsap.utils.selector(this.$el)

      this.$gsap
        .timeline({ onComplete: () => this.$nuxt.$emit('hero-animated') })
        .to(q('.slide-up'), {
          duration: 1,
          opacity: 1,
          y: 0,
          stagger: 0.15,
          delay: 0.3,
          ease: 'power3.out',
        })
        .to(
          q('.part-right'),
          {
            duration: 0.6,
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
          },
          '<'
        )
    },
  },
}
